import React, { Component } from "react";
import {
  Grid,
  Paper,
  Zoom,
  TextField,
  MenuItem,
  ButtonBase,
  CircularProgress,
  Button,
  Typography,
  FormControl,
  Dialog,
  DialogContent,
} from "@material-ui/core";
import { colors, metrics } from "../../../styles";
import { connect } from "react-redux";
import add from "../../../images/add.svg";
import CostCenterService from "../../../tools/CostCenterService";
import AircraftsTypesService from "../../../tools/AircraftsTypesService";
import AircraftsService from "../../../tools/AircraftsService";
import NotificationGroups from "../../../tools/NotificationGroups";
import UserService from "../../../tools/UserService";
import Step from "../../../components/Step";
import View from "../../../components/View";
import Modal from "./Modal.js";
import FlightStageService from "../../../tools/FlightStageService";
import moment from "moment";
import { msgSimple, msgAction } from "../../../actions/snackbarActions";
import MissionService from "../../../tools/MissionService";
import MultiSelect from "../../../components/MultiSelect";
import { navigate } from "../../../actions/routerResolve";
import PassengersModal from "../../../routes/settings/passengers/Modal.js";
import { DatePicker } from "material-ui-pickers";
import "moment/locale/pt-br";
import MomentUtils from "material-ui-pickers/utils/moment-utils";
import MuiPickersUtilsProvider from "material-ui-pickers/utils/MuiPickersUtilsProvider";

import { BrowserRouter as Router, Route, Link, Prompt } from "react-router-dom";

//SweetAlert
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { MISSION_STATUS, MissionStatusOption } from "../../../enums.js";
import PassengerService from "../../../tools/PassengerService.js";

const MySwal = withReactContent(Swal);

class MissionAdmin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isChanged: false, //Do not be afraid, le'ts go
      isImport: false, //Do not be afraid, le'ts go
      openModal: false,
      openAlert: false,
      openPax: false,
      removeId: "",
      disableRemove: false,
      mission: {
        id: "new",
        date: new Date(),
        status: MISSION_STATUS.SOLICITADO,
        cost_center_id: "",
        flight_denomination: "",
        aircraft_type_id: "",
        aircraft_id: "",
        flight_stages: [],
        notification_groups: [],
        notification_users: [],
      },
      profiles: ["Teste", "Teste 2"],
      user: {
        profile: "",
      },
      costCenter: [],
      aircraftTypes: [],
      aircrafts: [],
      notificationGroups: [],
      notificationUsers: [],
      users: [],
      modal: { id: "new" },
      modalPax: { id: "new" },
      status: MissionStatusOption,
      loading: true,
      result: true,
      preMission: {
        to: "",
        passengers_summary: "",
      },
      saveStep: false,
      saveStepMission: true,
      passengers: [],
      firstStep: {
        from: "",
        to: "",
        status: "Solicitado",
        date: null,
        local_time: null,
        arrival_date: null,
        arrival_time: null,
        passengers: [],
        observations: "",
        logbook_number: "",
      },
    };
    this.cleanInput = this.cleanInput.bind(this);
  }
  componentWillMount() {
    PassengerService.getPassenger(null, 999999, 1, null, null, null).then(
      async (result) => {
        if (result.ok) {
          let passengers = await this._handleIdPassengerMultiSelect(
            result.response.docs
          );
          this.setState({
            passengers: passengers,
          });
          console.log(passengers);
        } else {
          console.log(`Error ao tentar recuperar os passageiros`);
        }
      }
    );

    CostCenterService.getActive().then((result) => {
      if (result.ok) {
        this.setState({ costCenter: result.response });
        let { mission } = this.state;
        this.setState({
          mission: { ...mission, cost_center_id: result.response[0].id },
        });
      }
    });
    //buscar aeronaves ativas
    AircraftsService.getActive().then((result) => {
      if (result.ok) {
        this.setState({ aircrafts: result.response, loading: false });
        let { mission } = this.state;
        this.setState({
          mission: { ...mission, aircraft_id: result.response[0].id },
        });
      }
    });
    AircraftsTypesService.getActive().then((result) => {
      if (result.ok) {
        this.setState({ aircraftTypes: result.response, loading: false });
        let { mission } = this.state;
        this.setState({
          mission: { ...mission, aircraft_type_id: result.response[0].id },
        });
      }
    });

    UserService.get(null, null, true, null, true).then(async (response) => {
      if (response.ok) {
        let listUsers = response.response;
        listUsers = await this._handleIdMultiSelectU(listUsers);
        this.setState({ notificationUsers: listUsers });
      }
    });
    NotificationGroups.getActive().then(async (result) => {
      if (result.ok) {
        let listGroup = result.response;
        listGroup = await this._handleIdMultiSelectNG(listGroup);
        this.setState({ notificationGroups: listGroup });
        let { mission, notificationUsers } = this.state;
        this.setState({
          mission: { ...mission, notification_groups: listGroup },
        });
      }
    });
    AircraftsService.getActive().then((result) => {
      if (result.ok) {
        this.setState({ aircrafts: result.response, loading: false });
      }
    });
    if (this.props.match.params.id !== "new") {
      MissionService.getById(this.props.match.params.id).then(
        async (result) => {
          let { notification_groups, notification_users } = result.response;
          if (result.ok) {
            let missionToEdit = result.response;
            let firstStep =
              missionToEdit.flight_stages &&
              missionToEdit.flight_stages.length > 0
                ? missionToEdit.flight_stages[0]
                : null;

            this.setState({
              firstStep: {
                passengers:
                  firstStep.passengers.length > 0
                    ? await this._handleIdPassengerMultiSelect(
                        firstStep.passengers
                      )
                    : [],
              },
              mission: {
                ...result.response,
                flight_denomination: missionToEdit.flight_denomination,
                aircraft_id: missionToEdit.aircraft_id
                  ? missionToEdit.aircraft_id
                  : "",
                aircraft_type_id: missionToEdit.aircraft_type_id
                  ? missionToEdit.aircraft_type_id
                  : "",
                notification_groups: await this._handleIdMultiSelectNG(
                  notification_groups
                ),
                notification_users: await this._handleIdMultiSelectU(
                  notification_users
                ),
              },
              loading: false,
              disableRemove: missionToEdit.flight_stages.length > 1,
            });
            this.setState({
              preMission:
                missionToEdit.flight_stages[
                  missionToEdit.flight_stages.length - 1
                ],
            });
          }
        }
      );
    } else {
      MissionService.getTitle().then((result) => {
        if (result.ok) {
          let { mission } = this.state;
          this.setState({
            mission: {
              ...mission,
              flight_denomination: result.response.flightTitle,
            },
          });
          this.setState({ isChanged: true });
        }
      });
    }
    this.setState({ loading: false });
  }

  openPaxDialog = (value) => {
    if (value) {
      this.setState({ newPax: value });
    }
    this.setState({ openPax: !this.state.openPax });
  };

  handleClosePax = () => {
    this.setState({ openPax: !this.state.openPax });
  };

  handleClose = () => {
    this.setState({ openModal: !this.state.openModal });
  };

  handleClickOpen = (item) => {
    console.log("this.state.mission: ", this.state.mission);
    this.setState({ modal: item });
    this.setState({ openModal: !this.state.openModal });
  };

  handleTime = async (value) => {
    if (value === "") {
      return null;
    } else {
      return value;
    }
  };

  handleDate = async (value) => {
    if (value) {
      return moment(value).format("YYYY-MM-DD");
    }
    return null;
  };

  _handleIdMultiSelectNG = async (value) => {
    if (value) {
      return await value.map((element) => {
        if (element.users)
          return {
            value: element.id,
            label: element.name,
            groups: element.users,
          };
        else return { value: element.id, label: element.name };
      });
    }
    return null;
  };

  _handleIdMultiSelectU = async (value) => {
    if (value) {
      return await value.map((element) => {
        return {
          value: element.id,
          label:
            element.war_name +
            " - " +
            (element.first_name ? element.first_name : "") +
            " " +
            (element.last_name ? element.last_name : ""),
        };
      });
    }
    return null;
  };

  _handleIdMultiSelectSaveNG = async (value) => {
    if (value) {
      var listGrupo = [];
      let list = [];
      let list1 = [];
      await value.map((element) => {
        if (element.groups) {
          element.groups.map((el) => {
            list1.push(el.id);
          });
        } else list1.push(element.value);
      });

      listGrupo = listGrupo.concat(list1);
      return list;
    }
    return null;
  };

  _handleIdMultiSelect = async (value) => {
    // console.log('value:',value)
    if (value) {
      let list = await value.map((element) => element.value);
      return list;
    }
    return null;
  };

  _handleIdPassengerMultiSelect = async (value) => {
    if (value) {
      return await value.map((element) => {
        let label = [];
        label = label.concat(
          (element.first_name ? element.first_name : "") +
            " " +
            (element.last_name ? element.last_name : "") +
            " - " +
            (element.cpf ? element.cpf : "")
        );
        return { value: element.id, label: label };
      });
    }
    return null;
  };

  saveFirstStep = async () => {
    //To save the first step
    console.log("Saving the first step", this.state.firstStep);
    let item = this.state.firstStep;

    // tratando datas
    item.date = await this.handleDate(item.date);
    item.departure_date = await this.handleDate(item.departure_date);
    item.arrival_date = await this.handleDate(item.arrival_date);

    //tratando horas
    item.departure_time = await this.handleTime(item.departure_time);
    item.local_time = await this.handleTime(item.local_time);
    item.presentation_time = await this.handleTime(item.presentation_time);
    item.hangar_time_departure = await this.handleTime(
      item.hangar_time_departure
    );
    item.takeoff_time = await this.handleTime(item.takeoff_time);
    item.arrival_time = await this.handleTime(item.arrival_time);
    item.takeoff_time_utc = await this.handleTime(item.takeoff_time_utc);
    item.arrival_time_utc = await this.handleTime(item.arrival_time_utc);
    item.flight_time = await this.handleTime(item.flight_time);

    delete item.id;
    FlightStageService.create(item).then((result) => {
      if (result.ok) {
        FlightStageService.getById(result.response.id).then((res) => {
          if (res.ok) {
            console.log(res.response);
            let { mission } = this.state;
            let { flight_stages } = this.state.mission;
            flight_stages.push({ ...res.response });
            this.setState({ mission: { ...mission, flight_stages } });
          }
        });
      }
    });
  };

  handleRefreshState = async () => {
    PassengerService.getPassenger(null, 999999, 1, null, null, null).then(
      async (result) => {
        if (result.ok) {
          let passengers = await this._handleIdPassengerMultiSelect(
            result.response.docs
          );
          this.setState({
            passengers: passengers,
          });
          console.log(passengers);
        } else {
          console.log(`Error ao tentar recuperar os passageiros`);
        }
      }
    );
  };

  handleSavePax = (item) => {
    Swal.fire({
      title:
        "<strong>Deseja realmente salvar as alterações realizadas?</strong>",
      type: "info",
      // html:'',
      customClass: "{ z-index: 1000000 }",
      customContainerClass: "{ z-index: 100000 }",
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: '<i class="fa fa-thumbs-up"></i> Salvar',
      confirmButtonAriaLabel: "Salvar",
      cancelButtonText: '<i class="fa fa-thumbs-down"></i> Cancelar',
      cancelButtonAriaLabel: "Cancelar",
    }).then((result) => {
      console.log(item);
      if (!!result.value) {
        //Save user
        if (item.id === "new") {
          let { users } = this.state;
          users.push({ ...item });
          users.reverse();
          this.setState({ users });
          this.setState({ loading: true });
          delete item.id;
          PassengerService.create(item).then((result) => {
            if (result.ok) {
              this.handleRefreshState();
              this.props.msgSimple(
                item.first_name + " " + item.last_name + " criado com sucesso."
              );
            } else {
              let { users } = this.state;
              users = users.filter((e) => e.id !== "new");
              users.reverse();
              this.setState({ users });
              this.props.msgAction(
                'Erro ao criar "' +
                  item.first_name +
                  " " +
                  item.last_name +
                  '"',
                "TENTAR NOVAMENTE",
                () => this.handleSave(item)
              );
            }
          });
        }
        this.setState({ openPax: false, loading: false });
      } else
        return MySwal.fire({
          title: "<p>Operação cancelada!</p>",
          type: "error",
        });
    });
  };

  handleUpdateSave = (item) => {
    Swal.fire({
      title: "<strong>Deseja realmente salvar a etapa?</strong>",
      type: "info",
      customClass: "{ z-index: 1000000 }",
      customContainerClass: "{ z-index: 100000 }",
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: '<i class="fa fa-thumbs-up"></i> Sim',
      confirmButtonAriaLabel: "Sim",
      cancelButtonText: '<i class="fa fa-thumbs-down"></i> Não',
      cancelButtonAriaLabel: "Não",
    }).then(async (result) => {
      if (!!result.value) {
        this.setState({ saveStep: true, loading: true, isChanged: false });
        if (item.id === "new") {
          this.setState({ preMission: { ...item } });
          let { mission } = this.state;
          let { flight_stages } = this.state.mission;
          flight_stages.push({ ...item, id: "new" });
          let aux = flight_stages.filter(
            (element) => element.status !== "Finalizado"
          );
          let status = "Finalizado";
          if (aux.length) status = aux[0].status;
          this.setState({
            mission: { ...mission, flight_stages, status },
            isChanged: true,
          });
          moment.locale("pt-br");
          // tratando datas
          item.date = await this.handleDate(item.date);
          item.departure_date = await this.handleDate(item.departure_date);
          item.arrival_date = await this.handleDate(item.arrival_date);

          //tratando horas
          item.departure_time = await this.handleTime(item.departure_time);
          item.local_time = await this.handleTime(item.local_time);
          item.presentation_time = await this.handleTime(
            item.presentation_time
          );
          item.hangar_time_departure = await this.handleTime(
            item.hangar_time_departure
          );
          item.takeoff_time = await this.handleTime(item.takeoff_time);
          item.arrival_time = await this.handleTime(item.arrival_time);
          item.takeoff_time_utc = await this.handleTime(item.takeoff_time_utc);
          item.arrival_time_utc = await this.handleTime(item.arrival_time_utc);
          item.flight_time = await this.handleTime(item.flight_time);

          // Tratando ID's
          item.passengers = await this._handleIdMultiSelect(item.passengers);
          item.coord_pilots = await this._handleIdMultiSelect(
            item.coord_pilots
          );
          item.second_pilots = await this._handleIdMultiSelect(
            item.second_pilots
          );
          item.reserve_pilots = await this._handleIdMultiSelect(
            item.reserve_pilots
          );
          item.mechanics = await this._handleIdMultiSelect(item.mechanics);
          item.auxiliarys = await this._handleIdMultiSelect(item.auxiliarys);
          item.stewardess = await this._handleIdMultiSelect(item.stewardess);
          item.stewardess_reserve = await this._handleIdMultiSelect(
            item.stewardess_reserve
          );
          item.supplier_origin = await this._handleIdMultiSelect(
            item.supplier_origin
          );
          item.supplier_origin_service = await this._handleIdMultiSelect(
            item.supplier_origin_service
          );
          item.supplier_fuel = await this._handleIdMultiSelect(
            item.supplier_fuel
          );
          item.supplier_destination = await this._handleIdMultiSelect(
            item.supplier_destination
          );
          item.supplier_destination_service = await this._handleIdMultiSelect(
            item.supplier_destination_service
          );
          item.supplier_hotel = await this._handleIdMultiSelect(
            item.supplier_hotel
          );
          item.supplier_stewarde = await this._handleIdMultiSelect(
            item.supplier_stewarde
          );

          delete item.id;
          FlightStageService.create(item).then((result) => {
            if (result.ok) {
              FlightStageService.getById(result.response.id).then((res) => {
                if (res.ok) {
                  // this.props.msgAction('Etapa criada com sucesso.')
                  let { mission } = this.state;
                  let { flight_stages } = this.state.mission;
                  flight_stages = flight_stages.filter(
                    (element) => element.id !== "new"
                  );
                  flight_stages.push({ ...res.response });
                  this.setState({
                    mission: { ...mission, flight_stages },
                    isChanged: true,
                  });
                  this.setState({
                    saveStep: false,
                    disableRemove: this.state.mission.flight_stages.length > 1,
                  });
                  if (this.state.mission.id !== "new") {
                    this.setState({ loading: false });
                    this.props.msgAction("Etapa criada com sucesso.");
                    this.setState({ saveStepMission: false });
                    this.handleUpdateMissionWithoutConfirmBox();
                  } else {
                    this.setState({ loading: false });
                    this.props.msgAction(
                      "Etapa criada com sucesso. Favor salvar para gravar etapa"
                    );
                  }
                }
              });
            } else {
              let { mission } = this.state;
              let { flight_stages } = this.state.mission;
              flight_stages = flight_stages.filter(
                (element) => element.id !== "new"
              );
              this.setState({
                mission: { ...mission, flight_stages },
                loading: false,
              });
              this.props.msgAction(
                "Erro ao criar etapa",
                "TENTAR NOVAMENTE",
                () => this.handleSave({ ...item, id: "new" })
              );
              this.setState({ saveStep: false });
            }
          });
        } else {
          this.setState({ saveStepMission: true });
          let { mission } = this.state;
          let { flight_stages } = this.state.mission;
          let index = await flight_stages.findIndex(
            (element) => element.id === item.id
          );
          flight_stages[index].id = "new";
          this.setState({ mission: { ...mission, flight_stages } });
          // tratando datas
          item.date = await this.handleDate(item.date);
          item.departure_date = await this.handleDate(item.departure_date);
          item.arrival_date = await this.handleDate(item.arrival_date);

          //tratando horas
          item.departure_time = await this.handleTime(item.departure_time);
          item.local_time = await this.handleTime(item.local_time);
          item.presentation_time = await this.handleTime(
            item.presentation_time
          );
          item.hangar_time_departure = await this.handleTime(
            item.hangar_time_departure
          );
          item.takeoff_time = await this.handleTime(item.takeoff_time);
          item.arrival_time = await this.handleTime(item.arrival_time);
          item.takeoff_time_utc = await this.handleTime(item.takeoff_time_utc);
          item.arrival_time_utc = await this.handleTime(item.arrival_time_utc);
          item.flight_time = await this.handleTime(item.flight_time);

          // Tratando ID's
          item.passengers = await this._handleIdMultiSelect(item.passengers);
          item.coord_pilots = await this._handleIdMultiSelect(
            item.coord_pilots
          );
          item.second_pilots = await this._handleIdMultiSelect(
            item.second_pilots
          );
          item.reserve_pilots = await this._handleIdMultiSelect(
            item.reserve_pilots
          );
          item.mechanics = await this._handleIdMultiSelect(item.mechanics);
          item.auxiliarys = await this._handleIdMultiSelect(item.auxiliarys);
          item.stewardess = await this._handleIdMultiSelect(item.stewardess);
          item.stewardess_reserve = await this._handleIdMultiSelect(
            item.stewardess_reserve
          );
          item.supplier_origin = await this._handleIdMultiSelect(
            item.supplier_origin
          );
          item.supplier_origin_service = await this._handleIdMultiSelect(
            item.supplier_origin_service
          );
          item.supplier_fuel = await this._handleIdMultiSelect(
            item.supplier_fuel
          );
          item.supplier_destination = await this._handleIdMultiSelect(
            item.supplier_destination
          );
          item.supplier_destination_service = await this._handleIdMultiSelect(
            item.supplier_destination_service
          );
          item.supplier_hotel = await this._handleIdMultiSelect(
            item.supplier_hotel
          );
          item.supplier_stewarde = await this._handleIdMultiSelect(
            item.supplier_stewarde
          );

          FlightStageService.update(item.id, item).then((result) => {
            if (result.ok) {
              FlightStageService.getById(item.id).then((res) => {
                if (res.ok) {
                  let { mission } = this.state;
                  let { flight_stages } = this.state.mission;
                  let index = flight_stages.findIndex(
                    (element) => element.id === "new"
                  );
                  flight_stages.splice(index, 1, { ...res.response });
                  let aux = flight_stages.filter(
                    (element) => element.status !== "Finalizado"
                  );
                  let status = "Finalizado";
                  if (aux.length) status = aux[0].status;
                  if (this.props.match.params.id === "new") {
                    this.setState({ isChanged: true });
                  } else {
                    this.setState({ isImport: true });
                  }
                  this.setState({
                    mission: { ...mission, flight_stages, status },
                    isChanged: true,
                  });
                  this.setState({
                    saveStep: false,
                    disableRemove: this.state.mission.flight_stages.length > 1,
                  });
                  if (this.state.mission.id !== "new") {
                    this.setState({ loading: false });
                    this.props.msgAction("Etapa editada com sucesso.");
                    this.setState({ saveStepMission: false });
                    this.handleUpdateMissionWithoutConfirmBox();
                  } else {
                    this.setState({ loading: false });
                    this.props.msgAction(
                      "Etapa criada com sucesso. Favor salvar para gravar etapa"
                    );
                  }
                }
              });
              this.setState({ loading: false });
            } else {
              let { flight_stages } = this.state.mission;
              let index = flight_stages.findIndex(
                (element) => element.id === item.id
              );
              flight_stages[index].id = item.id;
              this.props.msgAction(
                "Erro ao editar etapa",
                "TENTAR NOVAMENTE",
                () => this.handleSave({ ...item })
              );
              this.setState({ saveStep: false });
            }
          });
        }
        this.setState({ openModal: false, loading: false });
      } else
        return MySwal.fire({
          title: "<p>Operação cancelada!</p>",
          type: "error",
        });
    });
  };

  handleSave = async (item) => {
    const flightStages = this.state.mission.flight_stages || [];

    // Obter data e horários do item
    const itemDate = item.departure_date
      ? moment(item.departure_date).format("YYYY-MM-DD")
      : null;
    const itemDepartureTime = item.local_time || "00:00";
    const itemArrivalTime = item.arrival_time || "00:00";

    // Verificar se há conflitos
    const isConflict = flightStages.some((stage) => {
      const stageDate = stage.departure_date
        ? moment(stage.departure_date).format("YYYY-MM-DD")
        : null;

      // Se as datas não coincidirem, não há conflito
      if (itemDate !== stageDate) {
        return false;
      }

      // Verificar sobreposição de horários
      const stageDepartureTime = stage.local_time || "00:00";
      const stageArrivalTime = stage.arrival_time || "00:00";

      // Converter horários para objetos Moment para comparação
      const itemDeparture = moment(
        `${itemDate} ${itemDepartureTime}`,
        "YYYY-MM-DD HH:mm"
      );
      const itemArrival = moment(
        `${itemDate} ${itemArrivalTime}`,
        "YYYY-MM-DD HH:mm"
      );
      const stageDeparture = moment(
        `${stageDate} ${stageDepartureTime}`,
        "YYYY-MM-DD HH:mm"
      );
      const stageArrival = moment(
        `${stageDate} ${stageArrivalTime}`,
        "YYYY-MM-DD HH:mm"
      );

      // Verificar se há sobreposição de intervalos
      return (
        itemDeparture.isBetween(stageDeparture, stageArrival, null, "[)") || // Decolagem do item dentro do intervalo
        itemArrival.isBetween(stageDeparture, stageArrival, null, "(]") || // Chegada do item dentro do intervalo
        stageDeparture.isBetween(itemDeparture, itemArrival, null, "[)") || // Decolagem do stage dentro do intervalo do item
        stageArrival.isBetween(itemDeparture, itemArrival, null, "(]") // Chegada do stage dentro do intervalo do item
      );
    });

    if (!isConflict) {
      this.handleUpdateSave(item);
    } else {
      Swal.fire({
        title: `<strong>Já possuí etapas no período selecionado.</strong>`,
        type: "warning",
        html: "Você deseja continar?",
        customClass: "{ z-index: 1000000 }",
        customContainerClass: "{ z-index: 100000 }",
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonText: '<i class="fa fa-thumbs-up"></i> Salvar',
        confirmButtonAriaLabel: "Continuar",
        cancelButtonText: '<i class="fa fa-thumbs-down"></i> Cancelar',
        cancelButtonAriaLabel: "Cancelar",
      }).then((result) => {
        if (result.value) {
          console.log("Operação aceita");
          this.handleUpdateSave(item);
        } else {
          return MySwal.fire({
            title: "<p>Operação cancelada!</p>",
            type: "error",
          });
        }
      });
    }
  };

  handleId = (value) => {
    if (value) return value;
    return null;
  };

  handleUpdateMissionWithoutConfirmBox = async () => {
    this.setState({ isChanged: false });
    if (this.state.saveStep) {
      this.props.msgSimple("Aguarde enquanto a etapa está sendo salva.");
      return null;
    }
    if (
      this.state.mission.flight_stages.length > 0 &&
      this.state.mission.cost_center_id
    ) {
      let { mission } = this.state;
      let {
        flight_stages,
        aircraft_type_id,
        aircraft_id,
        notification_groups,
        notification_users,
      } = this.state.mission;

      mission.date = flight_stages[0].date;
      // mission.date.setHours(flight_stages[0].presentation_time)
      flight_stages = flight_stages.map((element) => element.id);
      MissionService.update(this.state.mission.id, {
        ...mission,
        flight_stages,
        aircraft_id: await this.handleId(aircraft_id),
        aircraft_type_id: await this.handleId(aircraft_type_id),
        notification_groups: await this._handleIdMultiSelect(
          notification_groups
        ),
        notification_users: await this._handleIdMultiSelect(notification_users),
      }).then((result) => {
        if (result.ok) {
          this.setState({ isImport: false });
          if (this.state.saveStepMission) {
            this.props.navigate("/flight/" + this.props.match.params.id);
            this.props.msgSimple("Missão atualizada com sucesso.");
          } else {
            this.setState({
              preMission:
                mission.flight_stages[mission.flight_stages.length - 1],
            });
          }
          this.setState({ saveStepMission: true });
        } else {
          this.props.msgSimple("Não foi possível atualizar missão.");
          this.setState({ saveStepMission: true });
        }
      });
    } else {
      this.props.msgSimple(
        "Para atualizar missão é necessário uma etapa e preencher o Autorizado por"
      );
      this.setState({ saveStepMission: false });
    }
  };

  handleUpdateMission = async () => {
    Swal.fire({
      title: "<strong>Deseja realmente salvar a missão?</strong>",
      type: "info",
      customClass: "{ z-index: 1000000 }",
      customContainerClass: "{ z-index: 100000 }",
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: '<i class="fa fa-thumbs-up"></i> Sim',
      confirmButtonAriaLabel: "Sim",
      cancelButtonText: '<i class="fa fa-thumbs-down"></i> Não',
      cancelButtonAriaLabel: "Não",
    }).then(async (result) => {
      if (!!result.value) {
        this.setState({ isChanged: false });

        if (this.state.saveStep) {
          this.props.msgSimple("Aguarde enquanto a etapa está sendo salva.");
          return null;
        }
        if (
          this.state.mission.flight_stages.length > 0 &&
          this.state.mission.cost_center_id
        ) {
          this.setState({ loading: true });
          let { mission } = this.state;
          let {
            flight_stages,
            aircraft_type_id,
            aircraft_id,
            notification_groups,
            notification_users,
          } = this.state.mission;

          mission.date = flight_stages[0].date;
          // mission.date.setHours(flight_stages[0].presentation_time)
          flight_stages = flight_stages.map((element) => element.id);
          MissionService.update(this.state.mission.id, {
            ...mission,
            flight_stages,
            aircraft_id: await this.handleId(aircraft_id),
            aircraft_type_id: await this.handleId(aircraft_type_id),
            notification_groups: await this._handleIdMultiSelect(
              notification_groups
            ),
            notification_users: await this._handleIdMultiSelect(
              notification_users
            ),
          }).then((result) => {
            this.setState({ loading: false });
            if (result.ok) {
              this.setState({ isImport: false });
              if (this.state.saveStepMission) {
                this.props.navigate("/flight/" + this.props.match.params.id);
                this.props.msgSimple("Missão atualizada com sucesso.");
              } else {
                this.setState({
                  preMission:
                    mission.flight_stages[mission.flight_stages.length - 1],
                });
              }
              this.setState({ saveStepMission: true });
            } else {
              this.props.msgSimple("Não foi possível atualizar missão.");
              this.setState({ saveStepMission: true });
            }
          });
        } else {
          this.props.msgSimple("Para atualizar missão é necessário uma etapa");
          this.setState({ saveStepMission: false });
        }
      } else
        return MySwal.fire({
          title: "<p>Operação cancelada!</p>",
          type: "error",
        });
    });
  };

  handleSaveMission = async () => {
    Swal.fire({
      title: "<strong>Deseja realmente salvar a missão?</strong>",
      type: "info",
      customClass: "{ z-index: 1000000 }",
      customContainerClass: "{ z-index: 100000 }",
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: '<i class="fa fa-thumbs-up"></i> Sim',
      confirmButtonAriaLabel: "Sim",
      cancelButtonText: '<i class="fa fa-thumbs-down"></i> Não',
      cancelButtonAriaLabel: "Não",
    }).then(async (result) => {
      if (!!result.value) {
        this.setState({ loading: true });

        if (this.state.saveStep) {
          this.props.msgSimple("Aguarde enquanto a etapa está sendo salva.");
          return null;
        }

        if (this.state.firstStep.from || this.state.firstStep.to) {
          let item = this.state.firstStep;

          // tratando datas
          item.date = await this.handleDate(item.date);
          item.departure_date = await this.handleDate(item.departure_date);
          item.arrival_date = await this.handleDate(item.arrival_date);

          //tratando horas
          item.departure_time = await this.handleTime(item.departure_time);
          item.local_time = await this.handleTime(item.local_time);
          item.presentation_time = await this.handleTime(
            item.presentation_time
          );
          item.hangar_time_departure = await this.handleTime(
            item.hangar_time_departure
          );
          item.takeoff_time = await this.handleTime(item.takeoff_time);
          item.arrival_time = await this.handleTime(item.arrival_time);
          item.takeoff_time_utc = await this.handleTime(item.takeoff_time_utc);
          item.arrival_time_utc = await this.handleTime(item.arrival_time_utc);
          item.flight_time = await this.handleTime(item.flight_time);
          item.passengers = this.state.firstStep.passengers.map(
            (item) => item.value
          );

          delete item.id;

          FlightStageService.create(item).then((result) => {
            if (result.ok) {
              FlightStageService.getById(result.response.id).then(
                async (res) => {
                  if (res.ok) {
                    let { mission } = this.state;
                    let {
                      flight_stages,
                      aircraft_type_id,
                      aircraft_id,
                      notification_groups,
                      notification_users,
                    } = this.state.mission;

                    if (this.state.firstStep.date)
                      mission.date = await this.handleDate(
                        this.state.firstStep.date
                      );
                    // mission.date.setHours(flight_stages[0].presentation_time)
                    flight_stages.push({ ...res.response });
                    flight_stages = flight_stages.map((element) => element.id);

                    //To delete the id
                    delete mission.id;
                    MissionService.create({
                      ...mission,
                      flight_stages,
                      aircraft_id: aircraft_id
                        ? await this.handleId(aircraft_id)
                        : null,
                      aircraft_type_id: aircraft_type_id
                        ? await this.handleId(aircraft_type_id)
                        : null,
                      notification_groups: await this._handleIdMultiSelect(
                        notification_groups
                      ),
                      notification_users: await this._handleIdMultiSelect(
                        notification_users
                      ),
                    }).then((result) => {
                      this.setState({ loading: false });
                      if (result.ok) {
                        this.props.navigate("/flight/" + result.response.id);
                        this.props.msgSimple("Missão criada com sucesso.");
                      } else {
                        this.props.msgSimple("Não foi possível criar missão.");
                      }
                    });
                  }
                }
              );
            }
          });

          //To save the first step
          // this.saveFirstStep()
        } else {
          this.setState({ loading: false });

          this.props.msgSimple(
            "Para criar missão é necessário uma etapa e preencher o Autorizado por"
          );
        }
      } else
        return MySwal.fire({
          title: "<p>Operação cancelada!</p>",
          type: "error",
        });
    });
  };

  handleCancelSave = () => {
    Swal.fire({
      title: "<strong>Deseja sair sem salvar a nova missão?</strong>",
      type: "info",
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: '<i class="fa fa-thumbs-up"></i> Sim',
      confirmButtonAriaLabel: "Sim",
      cancelButtonText: '<i class="fa fa-thumbs-down"></i> Não',
      cancelButtonAriaLabel: "Não",
    }).then((result) => {
      if (!!result.value) {
        this.props.navigate("/");
      }
    });
  };

  handleCancelUpdate = () => {
    Swal.fire({
      title: "<strong>Deseja sair sem salvar as alterações na missão?</strong>",
      type: "info",
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: '<i class="fa fa-thumbs-up"></i> Sim',
      confirmButtonAriaLabel: "Sim",
      cancelButtonText: '<i class="fa fa-thumbs-down"></i> Não',
      cancelButtonAriaLabel: "Não",
    }).then((result) => {
      if (!!result.value) {
        this.props.navigate("/flight/" + this.props.match.params.id);
      }
    });
  };

  cleanInput = () => {
    let { mission } = this.state;
    this.setState({ mission: { ...mission, aircraft_id: "" } });
    console.log(mission);
  };

  removeStage = (id) => {
    Swal.fire({
      title: "<strong>Deseja realmente apagar a etapa?</strong>",
      type: "info",
      customClass: "{ z-index: 1000000 }",
      customContainerClass: "{ z-index: 100000 }",
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: '<i class="fa fa-thumbs-up"></i> Apagar',
      confirmButtonAriaLabel: "Apagar",
      cancelButtonText: '<i class="fa fa-thumbs-down"></i> Cancelar',
      cancelButtonAriaLabel: "Cancelar",
    }).then(async (result) => {
      if (!!result.value) {
        this.setState({ saveStepMission: true, removeId: id });
        FlightStageService.delete(this.state.removeId).then((res) => {
          if (res.ok) {
            let { mission } = this.state;
            let { flight_stages } = this.state.mission;
            let index = flight_stages.findIndex(
              (element) => element.id === this.state.removeId
            );
            flight_stages.splice(index, 1);
            if (this.state.mission.id !== "new") mission.status = "Alterado";
            this.setState({ mission: { ...mission, flight_stages } });
            this.setState({
              disableRemove: this.state.mission.flight_stages.length > 1,
            });
            this.props.msgAction("Etapa removida com sucesso.");
            if (this.state.mission.id !== "new") {
              this.setState({ saveStepMission: false });
              this.handleUpdateMissionWithoutConfirmBox();
            }
          }
        });
      } else
        return MySwal.fire({
          title: "<p>Operação cancelada!</p>",
          type: "error",
        });
    });
  };

  // To confirm if the user want exit of the route without save
  isGoAway = async (newLocation) => {
    await Swal.fire({
      title: "<strong>Deseja realmente sair da missão sem salvar?</strong>",
      type: "info",
      customClass: "{ z-index: 1000000 }",
      customContainerClass: "{ z-index: 100000 }",
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: '<i class="fa fa-thumbs-up"></i> Sair',
      confirmButtonAriaLabel: "Apagar",
      cancelButtonText: '<i class="fa fa-thumbs-down"></i> Cancelar',
      cancelButtonAriaLabel: "Cancelar",
    }).then(async (result) => {
      if (!!result.value) {
        // To block the Prompt confirmation and redirect
        this.setState({ isChanged: false });
        this.props.navigate(newLocation);
      }
    });
  };

  isImportSave = async (newLocation) => {
    await Swal.fire({
      title: "<strong>Não é possível sair sem salvar</strong>",
      type: "info",
      customClass: "{ z-index: 1000000 }",
      customContainerClass: "{ z-index: 100000 }",
      showCloseButton: false,
      showCancelButton: false,
      focusConfirm: false,
      confirmButtonText: '<i class="fa fa-thumbs-up"></i> OK',
      confirmButtonAriaLabel: "Apagar",
      cancelButtonText: '<i class="fa fa-thumbs-down"></i> Cancelar',
      cancelButtonAriaLabel: "Cancelar",
    }).then(async (result) => {
      if (!!result.value) {
        // To block the Prompt confirmation and redirect
      }
    });
  };

  render() {
    return (
      <main>
        <Dialog open={this.state.loading}>
          <DialogContent>
            <CircularProgress />
          </DialogContent>
        </Dialog>
        <Zoom in={true}>
          <Grid container item md={12}>
            <View
              {...this.state.mission}
              handleSaveMission={this.handleSaveMission}
              handleUpdateMission={this.handleUpdateMission}
              title={
                this.props.match.params.id === "new"
                  ? "NOVA MISSÃO"
                  : "EDITAR MISSÃO"
              }
            />
            <Modal
              openModal={this.state.openModal}
              func={this.handleClose}
              modal={this.state.modal}
              handleSave={this.handleSave}
              preMission={this.state.preMission}
            />
            <PassengersModal
              modal={this.state.modalPax}
              openModal={this.state.openPax}
              func={this.handleClosePax}
              handleSave={this.handleSavePax}
            />
            <Grid container style={styles.iboxMain}>
              <Paper style={{ width: "100%", padding: metrics.paddingPage }}>
                <Grid container spacing={8}>
                  <Grid item xs={12} md={6}>
                    <TextField
                      InputProps={{
                        readOnly: true,
                      }}
                      id="flight_denomination"
                      label="Título do voo"
                      style={{ width: "100%" }}
                      value={this.state.mission.flight_denomination}
                      onChange={(event) => {
                        let { mission } = this.state;
                        this.setState({
                          mission: {
                            ...mission,
                            flight_denomination:
                              event.target.value.toUpperCase(),
                          },
                        });
                        this.setState({ isChanged: true });
                      }}
                      margin="normal"
                    />
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <TextField
                      id="profile"
                      select
                      label="Aeronave"
                      style={{ width: "100%" }}
                      value={this.state.mission.aircraft_id}
                      openAlert
                      onChange={(event) => {
                        let { mission } = this.state;
                        this.setState({
                          mission: {
                            ...mission,
                            aircraft_id: event.target.value,
                          },
                        });
                      }}
                      // ref={this.aircraft_id}
                      margin="normal"
                      // InputProps={{
                      //   readOnly: true,
                      // }}
                    >
                      <MenuItem disabled>Selecione a Aeronave</MenuItem>
                      {this.state.aircrafts.map((element) => (
                        <MenuItem key={element.id} value={element.id}>
                          {element.marks}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                  <Grid item xs={12}>
                    <MultiSelect
                      value={this.state.mission.notification_groups}
                      suggestions={this.state.notificationGroups}
                      placeholder="Selecione um ou mais grupo de notificação"
                      label="Grupos a serem notificados"
                      isPax={{
                        isPax: false,
                        isGroup: false,
                        // openPaxDialog: this.openPaxDialog
                        openPaxDialog: false,
                      }}
                      onChange={(value) => {
                        // let { mission, notificationUsers } = this.state;
                        // this.setState({ mission: { ...mission, notification_groups: value, notificationUsers } })
                      }}
                    />
                  </Grid>
                  {this.props.match.params.id !== "new" ? null : (
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                      <h4>Solicitação de Voo</h4>
                    </Grid>
                  )}
                  {this.props.match.params.id !== "new" ? null : (
                    <Grid item xs={12} md={6}>
                      <TextField
                        id="from"
                        label="Local de embarque"
                        style={{ width: "100%" }}
                        value={this.state.firstStep.from}
                        onChange={(event) => {
                          let { firstStep } = this.state;
                          this.setState({
                            firstStep: {
                              ...firstStep,
                              from: event.target.value,
                            },
                          });
                        }}
                      />
                    </Grid>
                  )}
                  {this.props.match.params.id !== "new" ? null : (
                    <Grid item xs={12} md={6}>
                      <TextField
                        id="to"
                        label="Destino"
                        style={{ width: "100%" }}
                        value={this.state.firstStep.to}
                        onChange={(event) => {
                          let { firstStep } = this.state;
                          this.setState({
                            firstStep: { ...firstStep, to: event.target.value },
                          });
                        }}
                      />
                    </Grid>
                  )}

                  {this.props.match.params.id !== "new" ? null : (
                    <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                      <MuiPickersUtilsProvider
                        utils={MomentUtils}
                        moment={moment}
                        locale="pt-br"
                      >
                        <DatePicker
                          style={{ width: "100%" }}
                          label="Data de Decolagem*"
                          disablePast
                          format="DD/MM/YYYY"
                          cancelLabel="SAIR"
                          okLabel="OK"
                          value={this.state.firstStep.date}
                          onChange={(date) => {
                            let { firstStep } = this.state;
                            this.setState({
                              firstStep: {
                                ...firstStep,
                                date: date,
                                departure_date: date,
                                arrival_date: date,
                              },
                            });
                          }}
                          animateYearScrolling
                        />
                      </MuiPickersUtilsProvider>
                    </Grid>
                  )}
                  {this.props.match.params.id !== "new" ? null : (
                    <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                      <TextField
                        id="time"
                        label="Hora de Decolagem(Local)"
                        type="time"
                        // defaultValue="00:00"
                        style={{ width: "100%" }}
                        value={this.state.firstStep.local_time}
                        onChange={(event) => {
                          let { firstStep } = this.state;
                          this.setState({
                            firstStep: {
                              ...firstStep,
                              local_time: event.target.value,
                              takeoff_time: event.target.value,
                            },
                          });
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{
                          step: 300, // 5 min
                        }}
                      />
                    </Grid>
                  )}
                  {this.props.match.params.id !== "new" ? null : (
                    <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                      <MuiPickersUtilsProvider
                        utils={MomentUtils}
                        moment={moment}
                        locale="pt-br"
                      >
                        <DatePicker
                          style={{ width: "90%" }}
                          label="Data de Chegada"
                          format="DD/MM/YYYY"
                          clearable
                          clearLabel={"LIMPAR"}
                          cancelLabel="SAIR"
                          okLabel="OK"
                          minDate={this.state.firstStep.date}
                          value={this.state.firstStep.arrival_date}
                          onChange={(date) => {
                            let { firstStep } = this.state;
                            this.setState({
                              firstStep: { ...firstStep, arrival_date: date },
                            });
                          }}
                          animateYearScrolling
                        />
                      </MuiPickersUtilsProvider>
                    </Grid>
                  )}
                  {this.props.match.params.id !== "new" ? null : (
                    <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                      <TextField
                        id="time"
                        label="Hora de Chegada(Local)"
                        type="time"
                        // defaultValue="00:00"
                        style={{ width: "100%" }}
                        value={this.state.firstStep.arrival_time}
                        onChange={(event) => {
                          let { firstStep } = this.state;
                          this.setState({
                            firstStep: {
                              ...firstStep,
                              arrival_time: event.target.value,
                            },
                          });
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{
                          step: 300, // 5 min
                        }}
                      />
                    </Grid>
                  )}
                  {/* PASSAGEIROS */}
                  <Grid container spacing={8} style={{ marginTop: 40 }}>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                      <MultiSelect
                        isPax={{
                          isPax: true,
                          openPaxDialog: this.openPaxDialog,
                        }}
                        value={this.state.firstStep.passengers}
                        suggestions={this.state.passengers}
                        placeholder="Selecione os Passageiros"
                        label="Passageiros"
                        onChange={(value) => {
                          let { firstStep } = this.state;
                          this.setState({
                            firstStep: { ...firstStep, passengers: value },
                          });
                        }}
                      />
                    </Grid>
                  </Grid>
                  {this.props.match.params.id !== "new" ? null : (
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                      <TextField
                        id="request_obs"
                        label="Observações "
                        style={{ width: "100%" }}
                        value={this.state.firstStep.observations}
                        onChange={(event) => {
                          let { firstStep } = this.state;
                          this.setState({
                            firstStep: {
                              ...firstStep,
                              observations: event.target.value,
                            },
                          });
                        }}
                      />
                    </Grid>
                  )}

                  <Grid container spacing={8} style={{ marginTop: 20 }}>
                    {this.props.match.params.id === "new" ? null : (
                      <Grid
                        item
                        container
                        justify="center"
                        alignItems="center"
                        md={2}
                      >
                        <ButtonBase
                          onClick={() => this.handleClickOpen({ id: "new" })}
                          style={{
                            backgroundColor: colors.primary_darker,
                            color: colors.white,
                            borderRadius: 10,
                            width: 120,
                            height: 30,
                            alignItems: "center",
                            justifyItems: "centerd",
                          }}
                        >
                          <img src={add} style={{ width: 25, height: 25 }} />
                          <h5 style={{ margin: 0, marginLeft: 5 }}>
                            NOVA ETAPA
                          </h5>
                        </ButtonBase>
                      </Grid>
                    )}
                    {this.props.match.params.id === "new" ? (
                      <Grid
                        container
                        item
                        alignItems="center"
                        justify="flex-start"
                        xs={12}
                        sm={12}
                        md={9}
                        lg={9}
                        xl={9}
                      >
                        <Button
                          size="large"
                          onClick={this.handleSaveMission}
                          color="primary"
                          style={{
                            backgroundColor: colors.primary_darker,
                            color: "white",
                          }}
                        >
                          Salvar
                        </Button>
                        <Button
                          size="large"
                          onClick={this.handleCancelSave}
                          color="secondary"
                        >
                          Cancelar
                        </Button>
                      </Grid>
                    ) : (
                      <Grid
                        container
                        item
                        alignItems="center"
                        justify="flex-start"
                        xs={12}
                        sm={12}
                        md={9}
                        lg={9}
                        xl={9}
                      >
                        <Button
                          size="large"
                          onClick={this.handleUpdateMission}
                          color="primary"
                          style={{
                            backgroundColor: colors.primary_darker,
                            color: "white",
                          }}
                        >
                          Atualizar
                        </Button>
                        <Button
                          size="large"
                          onClick={this.handleCancelUpdate}
                          color="secondary"
                        >
                          Cancelar
                        </Button>
                      </Grid>
                    )}
                  </Grid>
                </Grid>
              </Paper>
              <Grid container spacing={8} style={{ marginTop: 10 }}>
                {this.state.mission.flight_stages.map((element, index) => (
                  <Step
                    index={index}
                    remove={this.removeStage}
                    disableRemove={this.state.disableRemove}
                    {...element}
                    onClick={() => this.handleClickOpen({ ...element })}
                  />
                ))}
              </Grid>
            </Grid>
          </Grid>
        </Zoom>
      </main>
    );
  }
}

const mapStateToProps = (state) => ({
  users: state.usersReducer.users,
});

const mapDispatchToProps = {
  msgSimple,
  msgAction,
  navigate,
};

export default connect(mapStateToProps, mapDispatchToProps)(MissionAdmin);

const styles = {
  iboxMain: {
    paddingLeft: "4%",
    paddingRight: "4%",
    marginTop: -20,
  },
  paper: {
    padding: metrics.paddingPage,
  },
  item: {
    // padding:5
  },
};



// WEBPACK FOOTER //
// ./src/routes/missions/mission-admin/index.js